const set = (key, value, isObj) => {
    value = isObj ? JSON.stringify(value) : value
    localStorage.setItem(key, value)
}

const get = (key, isObj) => {
    if (isObj) {
        return JSON.parse(localStorage.getItem(key))
    }
    return localStorage.getItem(key)
}

const remove = (key) => {
    localStorage.removeItem(key)
}

export default {
    set,
    get,
    remove,
}
